module.exports = __webpack_public_path__ + "img/b_10.ef8a89a7.jpg";